// extracted by mini-css-extract-plugin
export default {"input":"Ya84Sb","size-30":"aX_Dvn","size-34":"q0bBOH"};